export const queryKeys = {
  leadsAll: ["leads"] as const,
  leadFields: ["lead-fields"] as const,
  leadInbox: (filters: object) => ["leads", "inbox", filters] as const,
  leadStage: (stage: string, filters: object) => ["leads", "stage", stage, filters] as const,
  leadCard: (id: string) => ["leads", "card", id] as const,
  leadSequencesOf: (id: string) => ["leads", "sequences", id] as const,
  leadBookings: (id: string) => ["leads", "bookings", id] as const,
  pipeline: ["pipeline"] as const,
  leadOwners: ["pipeline", "owners"] as const,
  leadSequences: ["pipeline", "sequences"] as const,
  leadCalendar: ["pipeline", "calendar"] as const,
  leadFunnel: (query: object) => ["pipeline", "funnel", query] as const,
  leadScoring: ["pipeline", "scoring"] as const,
  leadSettings: ["pipeline", "settings"] as const,
  leadTemplatesAll: ["pipeline", "templates"] as const,
  leadTemplates: (filters: object) => ["pipeline", "templates", filters] as const,
  leadFormsAll: ["lead-forms"] as const,
  leadForm: (id: string) => ["lead-forms", id] as const,
  landingsAll: ["lead-landings"] as const,
  consentAll: ["consent"] as const,
  consentPeople: (filters: object) => ["consent", "people", filters] as const,
  suppressions: (filters: object) => ["consent", "suppressions", filters] as const,
  dsarRequests: ["consent", "requests"] as const,
  tenant: ["tenant"] as const,
  readiness: ["tenant", "readiness"] as const,
  liveSwitches: ["live-switches"] as const,
  apiKeys: (cursor: string | undefined) => ["api-keys", cursor ?? ""] as const,
  apiKeysAll: ["api-keys"] as const,
  teamMembers: (cursor: string | undefined) => ["team-members", cursor ?? ""] as const,
  teamMembersAll: ["team-members"] as const,
  teamInvitations: ["team-invitations"] as const,
  approvers: ["approvers"] as const,
  notifyPreferences: ["notify-preferences"] as const,
  audit: (filters: object) => ["audit", filters] as const,
  competitors: { all: ["competitors"] as const, list: ["competitors", "list"] as const, ads: (filters: object) => ["competitors", "ads", filters] as const },
  news: { all: ["news"] as const, list: (filters: object) => ["news", "list", filters] as const },
  knowledgeSummary: ["knowledge", "summary"] as const,
  knowledgeItems: (kind: string, cursor: string | undefined) => ["knowledge", "items", kind, cursor ?? ""] as const,
  knowledgeChanges: (kind: string, cursor: string | undefined) => ["knowledge", "changes", kind, cursor ?? ""] as const,
  vertical: ["vertical"] as const,
  archetypeUsage: (id: string) => ["vertical", "archetype", id, "usage"] as const,
  factsAll: ["facts"] as const,
  facts: (filters: object) => ["facts", "list", filters] as const,
  factsUsable: ["facts", "usable"] as const,
  brand: ["brand"] as const,
  brandPreview: (input: object) => ["brand", "preview", input] as const,
  topicsAll: ["topics"] as const,
  topics: (filters: object) => ["topics", "list", filters] as const,
  topicSimilar: (id: string) => ["topics", "similar", id] as const,
  topicSimilarToTitle: (title: string) => ["topics", "similar-title", title] as const,
  topicHistory: (id: string) => ["topics", "history", id] as const,
  topicCategories: ["topic-categories"] as const,
  topicExclusions: ["topic-exclusions"] as const,
  topicHooks: ["topic-hooks"] as const,
  themesAll: ["themes"] as const,
  themes: (month: string) => ["themes", month] as const,
  calendarAll: ["calendar"] as const,
  calendar: (year: number, includeHidden: boolean) => ["calendar", year, includeHidden] as const,
  weekPlansAll: ["week-plans"] as const,
  weekPlans: ["week-plans", "list"] as const,
  planSettings: ["week-plans", "settings"] as const,
  planOutputs: (id: string) => ["week-plans", "outputs", id] as const,
  themeOutputs: (id: string) => ["themes", "outputs", id] as const,
  outgoing: (from: string, to: string) => ["calendar", "outgoing", from, to] as const,
  queueAll: ["queue"] as const,
  queue: (filters: object) => ["queue", "list", filters] as const,
  queueCards: ["queue", "card"] as const,
  queueCard: (id: string) => ["queue", "card", id] as const,
  studioRuns: ["studio", "runs"] as const,
  studioRun: (id: string) => ["studio", "run", id] as const,
  goodHours: ["studio", "good-hours"] as const,
  publicApproval: (token: string) => ["public-approval", token] as const,
  billing: ["billing"] as const,
  billingStatus: ["billing", "status"] as const,
  accountDevices: ["account", "devices"] as const,
  // s10-mcp-b
  accountAssistants: ["account", "assistants"] as const,
  oauthConnections: (cursor: string | undefined) => ["oauth-connections", cursor ?? ""] as const,
  oauthConnectionsAll: ["oauth-connections"] as const,
  aiKeys: ["ai-keys"] as const,
  // s10-keys-b
  smsProvider: ["sms-provider"] as const,
  accountTenants: ["account", "tenants"] as const,
  accountCompanies: ["account", "companies"] as const,
  admin: {
    me: ["admin", "me"] as const,
    agencies: (hostId: string) => ["admin", "agencies", hostId] as const,
    hosts: ["admin", "hosts"] as const,
    hostLive: (id: string) => ["admin", "hosts", id, "live"] as const,
    reconciliation: (id: string, month: string) => ["admin", "hosts", id, "reconciliation", month] as const,
    tenants: (filter: { q: string; billingMode: string; emailStopped: boolean }) => ["admin", "tenants", filter] as const,
    tenantLive: (id: string) => ["admin", "tenants", id, "live"] as const,
    aiGrant: (id: string) => ["admin", "tenants", id, "ai-grant"] as const,
    usage: (month: string) => ["admin", "usage", month] as const,
    audit: ["admin", "audit"] as const,
    readiness: ["admin", "readiness"] as const,
  },
  schedules: ["schedules"] as const,
  assetsAll: ["assets"] as const,
  assets: (filters: object) => ["assets", "list", filters] as const,
  asset: (id: string) => ["assets", "one", id] as const,
  assetUsages: (id: string) => ["assets", "usages", id] as const,
  captures: ["captures"] as const,
  captureDomains: ["captures", "domains"] as const,
  cardTemplates: ["cards", "templates"] as const,
  cardCheck: (spec: object) => ["cards", "check", spec] as const,
  cardPreview: (spec: object) => ["cards", "preview", spec] as const,
  illustrationOptions: ["visuals", "illustrations", "options"] as const,
  channelsAll: ["channels"] as const,
  channels: ["channels", "list"] as const,
  channelNotices: ["channels", "notices"] as const,
  channelTargets: (id: string) => ["channels", "targets", id] as const,
  receipts: ["publish", "receipts"] as const,
  manualCards: (state: string) => ["publish", "manual", state] as const,
  ads: {
    all: ["ads"] as const,
    connections: ["ads", "connections"] as const,
    /** Outside `all` on purpose: refreshing after a choice must not ask again, the API refuses once the choice is made. */
    accounts: (id: string) => ["ad-accounts-to-choose", id] as const,
    assets: (id: string) => ["ads", "connections", id, "assets"] as const,
    pages: (id: string) => ["ads", "connections", id, "pages"] as const,
    limits: (id: string) => ["ads", "connections", id, "limits"] as const,
    campaigns: ["ads", "campaigns"] as const,
    adSets: (campaignId: string) => ["ads", "ad-sets", campaignId] as const,
    ads: (adSetId: string) => ["ads", "ads", adSetId] as const,
    keywords: (adSetId: string) => ["ads", "keywords", adSetId] as const,
    metrics: (level: string, from: string, to: string) => ["ads", "metrics", level, from, to] as const,
    daily: (level: string, id: string, from: string, to: string) => ["ads", "metrics", "daily", level, id, from, to] as const,
    productAds: ["ads", "product-ads"] as const,
    productAd: (id: string) => ["ads", "product-ads", id] as const,
    productOptions: (catalogId: string) => ["ads", "product-ads", "options", catalogId] as const,
    guards: ["ads", "guards"] as const,
    actions: (filters: object) => ["ads", "actions", filters] as const,
    alerts: ["ads", "alerts"] as const,
    cells: ["ads", "cells"] as const,
    cell: (id: string) => ["ads", "cells", id] as const,
    decisions: (id: string) => ["ads", "cells", id, "decisions"] as const,
    holds: ["ads", "holds"] as const,
    holdsWithStatus: (status: string) => ["ads", "holds", "status", status] as const,
    wizards: ["ads", "wizards"] as const,
    wizard: (id: string) => ["ads", "wizards", id] as const,
    wizardReview: (id: string) => ["ads", "wizards", id, "review"] as const,
    promotions: ["ads", "promotions"] as const,
    promotion: (id: string) => ["ads", "promotions", id] as const,
    forms: ["ads", "forms"] as const,
    formTemplates: (language: string) => ["ads", "form-templates", language] as const,
    audiences: ["ads", "audiences"] as const,
    catalogs: ["ads", "catalogs"] as const,
    scheduleSuggestion: ["ads", "schedule-suggestion"] as const,
    wizardCreatives: (topicId: string) => ["ads", "wizard-creatives", topicId] as const,
  },
  tracking: {
    all: ["tracking"] as const,
    config: ["tracking", "config"] as const,
    conversions: (filters: object) => ["tracking", "conversions", filters] as const,
    summary: (from: string, to: string) => ["tracking", "summary", from, to] as const,
    consent: (from: string, to: string) => ["tracking", "consent", from, to] as const,
    funnel: (from: string, to: string) => ["tracking", "funnel", from, to] as const,
  },
  analyticsHome: ["analytics", "home"] as const,
  funnel: (filters: object) => ["analytics", "funnel", filters] as const,
  scores: (kind: string) => ["analytics", "scores", kind] as const,
  goodHoursReport: ["analytics", "good-hours"] as const,
  socialMetrics: (filters: object) => ["analytics", "social-metrics", filters] as const,
  postHistory: (postId: string) => ["analytics", "post-history", postId] as const,
  reconcile: ["analytics", "reconcile"] as const,
  reportsAll: ["reports"] as const,
  reports: (cursor: string | undefined) => ["reports", "list", cursor ?? ""] as const,
  reportLatest: ["reports", "latest"] as const,
  reportWeek: (week: string) => ["reports", "week", week] as const,
  reportRendered: (week: string) => ["reports", "rendered", week] as const,
  agencyReport: (agencyId: string, week: string) => ["reports", "agency", agencyId, week] as const,
  me: ["me"] as const,
  agencyAll: (id: string) => ["agency", id] as const,
  agency: (id: string) => ["agency", id, "detail"] as const,
  agencyBrand: (id: string) => ["agency", id, "brand"] as const,
  agencyClients: (id: string, cursor: string | undefined) => ["agency", id, "clients", cursor ?? ""] as const,
  agencyMembersAll: (id: string) => ["agency", id, "members"] as const,
  agencyMembers: (id: string, cursor: string | undefined) => ["agency", id, "members", cursor ?? ""] as const,
  agencyInvitations: (id: string) => ["agency", id, "invitations"] as const,
  agencyAudit: (id: string, filters: object) => ["agency", id, "audit", filters] as const,
  aiUsageDays: (month: string) => ["ai-usage", "days", month] as const,
  aiUsageCalls: (filters: object) => ["ai-usage", "calls", filters] as const,
  linksAll: ["links"] as const,
  links: (cursor: string | undefined) => ["links", "list", cursor ?? ""] as const,
  linkQr: (id: string) => ["links", "qr", id] as const,
  linkStats: (id: string, days: number) => ["links", "stats", id, days] as const,
  tenantSettings: ["tenant", "settings"] as const,
  webhookEndpoints: ["webhooks", "endpoints"] as const,
  webhookDeliveriesAll: ["webhooks", "deliveries"] as const,
  webhookDeliveries: (filters: object) => ["webhooks", "deliveries", "list", filters] as const,
  webhookDelivery: (id: string) => ["webhooks", "deliveries", "one", id] as const,
  customers: {
    all: ["customers"] as const,
    list: (filters: object) => ["customers", "list", filters] as const,
    card: (id: string) => ["customers", "card", id] as const,
  },
  segments: {
    all: ["segments"] as const,
    list: ["segments", "list"] as const,
    one: (id: string) => ["segments", "one", id] as const,
    count: (id: string) => ["segments", "count", id] as const,
    presets: ["segments", "presets"] as const,
    options: ["segments", "options"] as const,
    preview: (rules: unknown) => ["segments", "preview", rules] as const,
  },
  proposals: {
    all: ["proposals"] as const,
    list: (status: string) => ["proposals", "list", status] as const,
  },
  dataSources: ["data-sources"] as const,
  imports: {
    all: ["imports"] as const,
    list: ["imports", "list"] as const,
    one: (id: string) => ["imports", "one", id] as const,
  },
  contentTemplates: {
    all: ["content-templates"] as const,
    list: (filters: object) => ["content-templates", "list", filters] as const,
    shelf: ["content-templates", "shelf"] as const,
    check: (input: object) => ["content-templates", "check", input] as const,
    preview: (id: string) => ["content-templates", "preview", id] as const,
  },
  profiles: ["profiles"] as const,
  angles: ["angles"] as const,
  templates: {
    all: ["templates"] as const,
    list: (filters: object) => ["templates", "list", filters] as const,
    one: (id: string) => ["templates", "one", id] as const,
  },
  campaigns: {
    all: ["campaigns"] as const,
    list: ["campaigns", "list"] as const,
    one: (id: string) => ["campaigns", "one", id] as const,
    report: (id: string) => ["campaigns", "report", id] as const,
    stats: (id: string) => ["campaigns", "stats", id] as const,
    dryRuns: (id: string) => ["campaigns", "dry-runs", id] as const,
  },
  journeys: {
    all: ["journeys"] as const,
    list: ["journeys", "list"] as const,
    one: (id: string) => ["journeys", "one", id] as const,
    stats: (id: string) => ["journeys", "stats", id] as const,
    enrollments: (id: string) => ["journeys", "enrollments", id] as const,
    steps: (id: string, enrollmentId: string) => ["journeys", "steps", id, enrollmentId] as const,
    peopleChecks: (id: string) => ["journeys", "people-check", id] as const,
    peopleCheck: (id: string, contactIds: readonly string[]) => ["journeys", "people-check", id, ...contactIds] as const,
  },
  referral: {
    all: ["referral"] as const,
    program: ["referral", "program"] as const,
    stats: ["referral", "stats"] as const,
  },
  messaging: {
    all: ["messaging"] as const,
    overview: ["messaging", "overview"] as const,
    dryRuns: ["messaging", "dry-runs"] as const,
    domains: ["messaging", "domains"] as const,
    emailStanding: ["messaging", "email-standing"] as const,
  },
};
